export const ajaxUploadMixin = {
    props: {
        ajaxChunkedUploadUrl: {type: String, default: '/ajax/chunkedupload'}
    },
    methods: {
        readChunkAsync: function(chunk) {
            return new Promise((resolve, reject) => {
                let fileReader = new FileReader();
                fileReader.onloadend = (event) => {
                    return resolve(event.target.result);
                }
                try {
                    fileReader.readAsDataURL(chunk);
                } catch(error) {
                    return reject(error);
                }
            })
        },
        uploadFileAsync: async function(file, uploadStatusEventHandlerCallback = null) {
            const CHUNK_SIZE = 512 * 1024;
            let pos = 0;
            let chunk = null;
            let id = null;
            if (uploadStatusEventHandlerCallback) {
                window.addEventListener('ajaxChunkUploaded', uploadStatusEventHandlerCallback)
            }
            while (pos <= file.size) {
                chunk = await this.readChunkAsync(file.slice(pos, pos + CHUNK_SIZE));
                pos += CHUNK_SIZE
                id = await this.uploadFileChunk(chunk, id).catch((error) => {
                    alert('Hiba történt a feltöltés során, próbálja meg később. Ha továbbra sem működik, értesítse a rendszergazdát.');
                });
                window.dispatchEvent(new CustomEvent('ajaxChunkUploaded', {detail: {size: file.size, pos: pos}}));
            }
            if (uploadStatusEventHandlerCallback) {
                window.removeEventListener('ajaxChunkUploaded', uploadStatusEventHandlerCallback)
            }
            return id;
        },
        uploadFileChunk: async function(chunkDataUrl, id) {
            return new Promise((resolve, reject) => {
                window.axios.post(this.ajaxChunkedUploadUrl, {id: id, data: chunkDataUrl})
                    .then((response) => {
                        resolve(response.data);
                    }).catch((error) => {
                        reject(error);
                })
            })
        },
    }
}